// extracted by mini-css-extract-plugin
export var linkText = "_of-0";